var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoteView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4167 4.58333V12.8333H12.8333V17.4167H4.58333L4.58333 4.58333L17.4167 4.58333ZM17.4167 2.75L4.58333 2.75C3.575 2.75 2.75 3.575 2.75 4.58333L2.75 17.4167C2.75 18.425 3.575 19.25 4.58333 19.25H13.75L19.25 13.75V4.58333C19.25 3.575 18.425 2.75 17.4167 2.75ZM11 12.8333L6.41667 12.8333V11L11 11V12.8333ZM15.5833 9.16667L6.41667 9.16667V7.33333L15.5833 7.33333L15.5833 9.16667Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteView);
export default __webpack_public_path__ + "static/media/note_view.363fa68d.svg";
export { ForwardRef as ReactComponent };